import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
// import ButtonWithIcon from '../../components/ButtonWithIcon';
import TypoFramed from '../../components/TypoFramed';
import PopupPage from '../../components/PopupPage';
import styles from './styles';
// import { ReactComponent as Play } from '../../res/play.svg';

class PopupMarianneLouis extends React.Component {
  render() {
    const { data, classes, open, onClose, baseUrl } = this.props;
    const imgSrc = `${baseUrl}/popups/${parse(data.popup.marianneLouis.imgSrc)}`;
    return (
      <PopupPage open={open} onClose={onClose}>
        <div>
          <div className={classes.container}>
            <div className={classes.titleBlock}>
              <div className={classes.title}>
                <Typography variant="h3">{parse(data.popup.marianneLouis.title)}</Typography>
                <TypoFramed frame="black" className={classes.autor} space={false}>
                  {parse(data.popup.marianneLouis.subtitle)}
                </TypoFramed>
              </div>
              <img key="img" src={imgSrc} alt="" className={classes.image} />
            </div>
            <div className={classes.asideBlock}>
              <Typography variant="h3" color="secondary">
                {parse(data.popup.marianneLouis.quote)}
              </Typography>
            </div>
          </div>
          <div className={classes.desc}>
            <Typography variant="body1" className={classes.descLeft}>
              {parse(data.popup.marianneLouis.desc1)}
            </Typography>
            <div className={classes.descRight}>
              <Typography variant="body1">{parse(data.popup.marianneLouis.desc2)}</Typography>
              {/* <ButtonWithIcon
                color="purple"
                icon={<Play />}
                // onClick={() => this.setState({ popupArticle1: true })}
              >
                {parse(data.popup.marianneLouis.itvBtn)}
              </ButtonWithIcon> */}
            </div>
          </div>
        </div>
      </PopupPage>
    );
  }
}

PopupMarianneLouis.propTypes = {
  data: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  baseUrl: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default withStyles(styles)(PopupMarianneLouis);
